import { render, staticRenderFns } from "./RecordPayment.vue?vue&type=template&id=5037a787&scoped=true&"
import script from "./RecordPayment.vue?vue&type=script&lang=js&"
export * from "./RecordPayment.vue?vue&type=script&lang=js&"
import style0 from "./RecordPayment.vue?vue&type=style&index=0&id=5037a787&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037a787",
  null
  
)

export default component.exports